// import React, { useEffect, useState, useCallback } from "react";
// import { MapContainer, TileLayer, GeoJSON, LayersControl, useMap, Popup } from "react-leaflet"; // Added Popup
// import "leaflet/dist/leaflet.css";
// import parseGeoraster from "georaster";
// import GeoRasterLayer from "georaster-layer-for-leaflet";
// // import L from "leaflet";
// import booleanPointInPolygon from "@turf/boolean-point-in-polygon";
// import { point, polygon } from "@turf/helpers";
// import { FaCircleInfo } from "react-icons/fa6";


// const INITIAL_VIEW_STATE = {
//   longitude: 125.7275,
//   latitude: -8.8742,
// };

// // Component to add GeoTIFF as a layer with GeoJSON mask
// const GeoTIFFBaseLayer = ({ tiffUrl, layerName }) => {
//   const map = useMap();
//   const [geoRasterLayer, setGeoRasterLayer] = useState(null);
//   const [debugMode] = useState(false);
//   const [,setLoadingError] = useState(null);

//   useEffect(() => {
//     const loadGeoTIFFAndMask = async () => {
//       setLoadingError(null);
//       try {
//         const geoJsonResponse = await fetch("/DATA/OSMbased_adm0_boundary.json");
//         if (!geoJsonResponse.ok) {
//           throw new Error(`Failed to fetch GeoJSON for mask: ${geoJsonResponse.statusText}`);
//         }
//         const geoJson = await geoJsonResponse.json();

//         if (!geoJson.features || geoJson.features.length === 0) {
//             console.warn("Mask GeoJSON has no features. Masking will not work.");
//         }
//         const geoJsonFeature = geoJson.features[0];

//         const tiffResponse = await fetch(tiffUrl);
//         if (!tiffResponse.ok) {
//           throw new Error(`Failed to fetch TIFF: ${tiffResponse.statusText}`);
//         }
//         const arrayBuffer = await tiffResponse.arrayBuffer();
//         const georaster = await parseGeoraster(arrayBuffer);

//         const isPointInBoundary = (lat, lng) => {
//             if (!geoJsonFeature || !geoJsonFeature.geometry) return false;
//             const pt = point([lng, lat]);
//             const geom = geoJsonFeature.geometry;

//             if (geom.type === "Polygon") {
//                 return booleanPointInPolygon(pt, polygon(geom.coordinates));
//             } else if (geom.type === "MultiPolygon") {
//                 return geom.coordinates.some((coords) =>
//                     booleanPointInPolygon(pt, polygon(coords))
//                 );
//             }
//             return false;
//         };

//         function getColor(value) {
//           if (value === null || value === undefined) return "transparent";
//           if (value === 0) return "transparent";
//           if (value === 1) return "rgb(148, 203, 85)";
//           if (value === 2) return "rgb(243, 235, 18)";
//           if (value === 3) return "rgb(243, 155, 58)";
//           if (value === 4) return "rgb(230, 45, 58)";
//           return "transparent";
//         }

//         function hexToRgb(hex) {
//           if (hex === "transparent" || !hex) return [0, 0, 0, 0];
//           const match = hex.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
//           if (match) {
//             return [parseInt(match[1]), parseInt(match[2]), parseInt(match[3]), 1];
//           }
//           return [0, 0, 0, 0];
//         }


//         const layer = new GeoRasterLayer({
//           georaster,
//           opacity: 1,
//           resolution: 256,
//           pixelValuesToColorFn: (values) => {
//             const value = values[0];
//             return getColor(value);
//           },
//           drawFunction: (canvas, ctx, georaster, pixelX, pixelY) => {
//             const { xmin, ymax, pixelWidth, pixelHeight, width, height } = georaster;
//             const imageData = ctx.createImageData(width, height);

//             for (let y = 0; y < height; y++) {
//               for (let x = 0; x < width; x++) {
//                 const pixelIndex = (y * width + x) * 4;
//                 const lng = xmin + x * pixelWidth;
//                 const lat = ymax - y * pixelHeight;

//                 const pixelValue = georaster.values[0][y][x];
//                 const color = getColor(pixelValue);
//                 const [r, g, b, a] = hexToRgb(color);

//                 if (debugMode || isPointInBoundary(lat, lng)) {
//                   imageData.data[pixelIndex] = r;
//                   imageData.data[pixelIndex + 1] = g;
//                   imageData.data[pixelIndex + 2] = b;
//                   imageData.data[pixelIndex + 3] = a * 255;
//                 } else {
//                   imageData.data[pixelIndex + 3] = 0;
//                 }
//               }
//             }
//             ctx.putImageData(imageData, 0, 0);
//           },
//         });

//         if (geoRasterLayer) {
//           map.removeLayer(geoRasterLayer);
//         }
//         setGeoRasterLayer(layer);
//         map.addLayer(layer);
//         map.fitBounds(layer.getBounds());

//       } catch (error) {
//         console.error(`Error loading TIFF or GeoJSON for ${layerName}:`, error);
//         setLoadingError(error.message);
//       }
//     };

//     loadGeoTIFFAndMask();

//     return () => {
//       if (geoRasterLayer && map.hasLayer(geoRasterLayer)) {
//         map.removeLayer(geoRasterLayer);
//       }
//     };
//   }, [map, tiffUrl, layerName, debugMode, geoRasterLayer]);
// };


// const InfoButton = ({ onClick }) => {
//   useMap();
//   return (
//     <div
//       style={{
//         position: "absolute",
//         bottom: "70px",
//         left: "10px",
//         padding: "8px",
//         borderRadius: "5px",
//         fontSize: "15px",
//         cursor: "pointer",
//         zIndex: 999,
//         backgroundColor: 'white',
//         boxShadow: '0 0 5px rgba(0,0,0,0.3)'
//       }}
//       onClick={onClick}
//     >
//       <FaCircleInfo />
//     </div>
//   );
// };




// const CFDashboard = () => {
//   const [info, setInfo] = useState(false);
//   const [adm1Data, setAdm1Data] = useState(null);
//   const [adm2Data, setAdm2Data] = useState(null);
//   const [adm3Data, setAdm3Data] = useState(null);

//   const [clickedFeaturePopup, setClickedFeaturePopup] = useState(null);

//   const handleFeatureClick = useCallback((feature, latlng) => {
//     setClickedFeaturePopup({
//       position: latlng,
//       properties: feature.properties,
//     });
//   }, []);

//   const onEachFeatureWithPopup = useCallback((feature, layer) => {
//     layer.on({
//       click: (e) => {
//         handleFeatureClick(feature, e.latlng);
//       },
//     });
//   }, [handleFeatureClick]);

//   useEffect(() => {
//     const fetchGeoJSONData = async () => {
//       try {
//         const [response1, response2, response3] = await Promise.all([
//           fetch("/DATA/OSMbased_adm1_boundary.json"),
//           fetch("/DATA/OSMbased_adm2_boundary.json"),
//           fetch("/DATA/OSMbased_adm3_boundary.json"),
//         ]);

//         const [json1, json2, json3] = await Promise.all([
//           response1.json(),
//           response2.json(),
//           response3.json(),
//         ]);

//         setAdm1Data(json1);
//         setAdm2Data(json2);
//         setAdm3Data(json3);
//         console.log("All GeoJSON boundary data loaded.");
//       } catch (error) {
//         console.error("Error loading GeoJSON boundary data:", error);
//       }
//     };
//     fetchGeoJSONData();
//   }, []);


//   return (
//     <div className="cf-dashboard-container">
//       <div className="map-container-cf-dashboard">
//         <MapContainer
//           center={[INITIAL_VIEW_STATE.latitude, INITIAL_VIEW_STATE.longitude]}
//           zoom={8}
//           style={{ width: "100%", height: "82.7vh" }}
//         >

//           <LayersControl position="topright">
//             <LayersControl.BaseLayer name="OpenStreetMap" checked>
//               <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
//             </LayersControl.BaseLayer>
//             <LayersControl.BaseLayer name="Carto Light">
//               <TileLayer
//                 url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//                 attribution="&copy; CartoDB"
//               />
//             </LayersControl.BaseLayer>

//             <LayersControl.Overlay checked name="Fire Risk Layer">
//               <GeoTIFFBaseLayer
//                 tiffUrl="/cityfire/Multiclass_Fire_Risk_RF_April2025_F2.tif"
//                 layerName="Fire Risk Layer"
//               />
//             </LayersControl.Overlay>

//             {/* GeoJSON Boundary Layers with Popup Logic - Colors set to Black */}
//             {adm1Data && (
//               <LayersControl.Overlay name="Municipality">
//                 <GeoJSON
//                   data={adm1Data}
//                   style={() => ({
//                       color: "#000000", // Black color
//                       weight: 2,
//                       opacity: 0.7,
//                       fillOpacity: 0.1
//                   })}
//                   onEachFeature={onEachFeatureWithPopup}
//                 />
//               </LayersControl.Overlay>
//             )}
//             {adm2Data && (
//               <LayersControl.Overlay name="Post Admin">
//                 <GeoJSON
//                   data={adm2Data}
//                   style={() => ({
//                       color: "#000000", // Black color
//                       weight: 1.5,
//                       opacity: 0.7,
//                       fillOpacity: 0.1
//                   })}
//                   onEachFeature={onEachFeatureWithPopup}
//                 />
//               </LayersControl.Overlay>
//             )}
//             {adm3Data && (
//               <LayersControl.Overlay name="Suco" checked> {/* Default active */}
//                 <GeoJSON
//                   data={adm3Data}
//                   style={() => ({
//                       color: "#000000", // Black color
//                       weight: 1,
//                       opacity: 0.7,
//                       fillOpacity: 0.1
//                   })}
//                   onEachFeature={onEachFeatureWithPopup}
//                 />
//               </LayersControl.Overlay>
//             )}

//           </LayersControl>

//           {info && (
//             <div
//               style={{
//                 position: "absolute",
//                 bottom: "80px",
//                 left: "35px",
//                 fontSize: "12px",
//                 zIndex: 1000,
//                 backgroundColor: "white",
//                 padding: "5px",
//                 borderRadius: "5px",
//                 boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//               }}
//             >
//               72 hour fire risk probability information based on latest data is available from NDVI, LST.
//             </div>
//           )}
//           <InfoButton onClick={() => setInfo(!info)} />

//           {/* Popup for clicked GeoJSON Feature */}
//           {clickedFeaturePopup && clickedFeaturePopup.properties && (
//             <Popup
//               position={clickedFeaturePopup.position}
//               onClose={() => setClickedFeaturePopup(null)}
//             >
//               {/* Removed maxHeight and overflowY for full size, or minimal styling */}
//               <div style={{ paddingRight: '10px' }}>
//                 <h5>Suco Details:</h5>
//                 {/* Explicitly display only the desired properties */}
//                 {clickedFeaturePopup.properties.ADM1 && (
//                     <p><strong>Municipality:</strong> {clickedFeaturePopup.properties.ADM1}</p>
//                 )}
//                 {clickedFeaturePopup.properties.ADM2 && (
//                     <p><strong>Post Admin:</strong> {clickedFeaturePopup.properties.ADM2}</p>
//                 )}
//                 {clickedFeaturePopup.properties.ADM3 && (
//                     <p><strong>Suco:</strong> {clickedFeaturePopup.properties.ADM3}</p>
//                 )}

//                 {(clickedFeaturePopup.properties.Population ||
//                   clickedFeaturePopup.properties.Male ||
//                   clickedFeaturePopup.properties.Female ||
//                   clickedFeaturePopup.properties.Household ||
//                   clickedFeaturePopup.properties.Area_sqkm) && (
//                     <hr style={{ margin: '5px 0' }} />
//                 )}

//                 {clickedFeaturePopup.properties.Population && (
//                     <p><strong>Total Population:</strong> {clickedFeaturePopup.properties.Population.toLocaleString()}</p>
//                 )}
//                 {clickedFeaturePopup.properties.Male && (
//                     <p><strong>Total Male:</strong> {clickedFeaturePopup.properties.Male.toLocaleString()}</p>
//                 )}
//                 {clickedFeaturePopup.properties.Female && (
//                     <p><strong>Total Female:</strong> {clickedFeaturePopup.properties.Female.toLocaleString()}</p>
//                 )}
//                 {clickedFeaturePopup.properties.Household && (
//                     <p><strong>Households:</strong> {clickedFeaturePopup.properties.Household.toLocaleString()}</p>
//                 )}
//                 {clickedFeaturePopup.properties.Area_sqkm && (
//                     <p><strong>Area (km²):</strong> {clickedFeaturePopup.properties.Area_sqkm.toFixed(2)}</p>
//                 )}

//               </div>
//             </Popup>
//           )}

// <div className="legend-home">
//               <h4>Legend</h4>
//               <div className="legendss-items">
//               <div className="legendss-item">
//                   <i style={{ background: "rgb(148, 203, 85)", opacity: "0.8", border: "1px solid black"   }}></i>
//                   <span>No-Risk</span>
//                 </div>
//                 <div className="legendss-item">
//                   <i style={{ background: "rgb(243, 235, 18)", opacity: "0.8", border: "1px solid black"   }}></i>
//                   <span>Low-Risk</span>
//                 </div>
//                 <div className="legendss-item">
//                   <i style={{ background: "rgb(243, 155, 58)", opacity: "0.8", border: "1px solid black"   }}></i>
//                   <span>Medium-Risk</span>
//                 </div>
//                 <div className="legendss-item">
//                   <i style={{ background: "rgb(230, 45, 58)", opacity: "0.8", border: "1px solid black"   }}></i>
//                   <span>High-Risk</span>
//                 </div>
//               </div>
//             </div>

//         </MapContainer>
//       </div>
//     </div>
//   );
// };

// export default CFDashboard;



import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import { MapContainer, TileLayer, GeoJSON, LayersControl, useMap, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import parseGeoraster from "georaster";
import GeoRasterLayer from "georaster-layer-for-leaflet";
import booleanPointInPolygon from "@turf/boolean-point-in-polygon";
import { point, polygon } from "@turf/helpers";
import { FaCircleInfo } from "react-icons/fa6";
import { Box, IconButton } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowCircleLeft,
  faArrowCircleRight,
} from "@fortawesome/free-solid-svg-icons";
import { MapHomeControl, MapLegendControl } from "../../../common/MapControls/MapControls";


const INITIAL_VIEW_STATE = {
  longitude: 125.7275,
  latitude: -8.8742,
  zoom: 8
};

// Component to add GeoTIFF as a layer with GeoJSON mask
const GeoTIFFBaseLayer = ({ tiffUrl, layerName }) => {
  const map = useMap();
  const geoRasterLayerRef = useRef(null);

  useEffect(() => {
    const loadGeoTIFFAndMask = async () => {
      try {
        const geoJsonResponse = await fetch("/DATA/OSMbased_adm0_boundary.json");
        if (!geoJsonResponse.ok) {
          throw new Error(`Failed to fetch GeoJSON for mask: ${geoJsonResponse.statusText}`);
        }
        const geoJson = await geoJsonResponse.json();

        if (!geoJson.features || geoJson.features.length === 0) {
            console.warn("Mask GeoJSON has no features. Masking will not work.");
        }
        const geoJsonFeature = geoJson.features[0];

        const tiffResponse = await fetch(tiffUrl);
        if (!tiffResponse.ok) {
          throw new Error(`Failed to fetch TIFF: ${tiffResponse.statusText}`);
        }
        const arrayBuffer = await tiffResponse.arrayBuffer();
        const georaster = await parseGeoraster(arrayBuffer);

        const isPointInBoundary = (lat, lng) => {
            if (!geoJsonFeature || !geoJsonFeature.geometry) return false;
            const pt = point([lng, lat]);
            const geom = geoJsonFeature.geometry;

            if (geom.type === "Polygon") {
                return booleanPointInPolygon(pt, polygon(geom.coordinates));
            } else if (geom.type === "MultiPolygon") {
                return geom.coordinates.some((coords) =>
                    booleanPointInPolygon(pt, polygon(coords))
                );
            }
            return false;
        };

        function getColor(value) {
          if (value === null || value === undefined) return "transparent";
          if (value === 0) return "rgb(148, 203, 85)";
          if (value === 1) return "rgb(243, 235, 18)";
          if (value === 2) return "rgb(243, 155, 58)";
          if (value === 3) return "rgb(230, 45, 58)";
          return "transparent";
        }

        function hexToRgb(hex) {
          if (hex === "transparent" || !hex) return [0, 0, 0, 0];
          const match = hex.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
          if (match) {
            return [parseInt(match[1]), parseInt(match[2]), parseInt(match[3]), 1];
          }
          return [0, 0, 0, 0];
        }


        const layer = new GeoRasterLayer({
          georaster,
          opacity: 1,
          resolution: 256,
          pixelValuesToColorFn: (values) => {
            const value = values[0];
            return getColor(value);
          },
          drawFunction: (canvas, ctx, georaster, pixelX, pixelY) => {
            const { xmin, ymax, pixelWidth, pixelHeight, width, height } = georaster;
            const imageData = ctx.createImageData(width, height);
            const debugMode = false;

            for (let y = 0; y < height; y++) {
              for (let x = 0; x < width; x++) {
                const pixelIndex = (y * width + x) * 4;
                const lng = xmin + x * pixelWidth;
                const lat = ymax - y * pixelHeight;

                const pixelValue = georaster.values[0][y][x];
                const color = getColor(pixelValue);
                const [r, g, b, a] = hexToRgb(color);

                if (debugMode || isPointInBoundary(lat, lng)) {
                  imageData.data[pixelIndex] = r;
                  imageData.data[pixelIndex + 1] = g;
                  imageData.data[pixelIndex + 2] = b;
                  imageData.data[pixelIndex + 3] = a * 255;
                } else {
                  imageData.data[pixelIndex + 3] = 0;
                }
              }
            }
            ctx.putImageData(imageData, 0, 0);
          },
        });
        
        if (geoRasterLayerRef.current) {
          map.removeLayer(geoRasterLayerRef.current);
        }

        layer.addTo(map);
        geoRasterLayerRef.current = layer;
        map.fitBounds(layer.getBounds());

      } catch (error) {
        console.error(`Error loading TIFF or GeoJSON for ${layerName}:`, error);
      }
    };

    loadGeoTIFFAndMask();

    return () => {
      if (geoRasterLayerRef.current) {
        map.removeLayer(geoRasterLayerRef.current);
        geoRasterLayerRef.current = null;
      }
    };
  }, [map, tiffUrl, layerName]);

  return null;
};


const InfoButton = ({ onClick }) => {
  useMap();
  // Leaflet's own drag/click handling swallows clicks on overlay controls
  // unless propagation to the map is explicitly disabled on the DOM node.
  const btnRef = useCallback((node) => {
    if (node) {
      L.DomEvent.disableClickPropagation(node);
      L.DomEvent.disableScrollPropagation(node);
    }
  }, []);
  return (
    <div
      ref={btnRef}
      style={{
        position: "absolute",
        bottom: "20px",
        left: "12px",
        padding: "8px",
        borderRadius: "8px",
        fontSize: "15px",
        cursor: "pointer",
        background: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(10px) brightness(1.1)",
        WebkitBackdropFilter: "blur(10px) brightness(1.1)",
        border: "1px solid rgba(0, 0, 0, 0.08)",
        color: "#333333",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        transition: "all 0.2s ease",
        zIndex: 1000,
      }}
      onClick={onClick}
    >
      <FaCircleInfo />
    </div>
  );
};


const CFDashboard = () => {
  const [info, setInfo] = useState(false);
  const infoRef = useRef(null);
  const infoPanelRef = useCallback((node) => {
    infoRef.current = node;
    if (node) {
      L.DomEvent.disableClickPropagation(node);
      L.DomEvent.disableScrollPropagation(node);
    }
  }, []);
  useEffect(() => {
    if (!info) return;
    const handleClickOutside = (e) => {
      if (infoRef.current && !infoRef.current.contains(e.target)) setInfo(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [info]);
  const [adm1Data, setAdm1Data] = useState(null);
  const [adm2Data, setAdm2Data] = useState(null);
  const [adm3Data, setAdm3Data] = useState(null);
  const [clickedFeaturePopup, setClickedFeaturePopup] = useState(null);

  const hardcodedDates = useMemo(() => [
    "2025-08-13",
    "2025-08-14",
    "2025-08-15",
  ], []);

  const [selectedDateIndex, setSelectedDateIndex] = useState(0);
  const [selectedDate, setSelectedDate] = useState(hardcodedDates[0]);
  const [showFilterPanel, setShowFilterPanel] = useState(false);

  useEffect(() => {
    setSelectedDate(hardcodedDates[selectedDateIndex]);
  }, [selectedDateIndex, hardcodedDates]);

  const handlePrevDate = () => {
    if (selectedDateIndex > 0) {
      setSelectedDateIndex((prev) => prev - 1);
    }
  };

  const handleNextDate = () => {
    if (selectedDateIndex < hardcodedDates.length - 1) {
      setSelectedDateIndex((prev) => prev + 1);
    }
  };

  // --- MODIFIED FUNCTION TO MATCH THE REQUESTED FORMAT ---
  const formatDateForDisplay = (dateString, offset) => {
    if (!dateString) return "--";
    return `${dateString}_UTC00 + ${offset}d : ${dateString}[UTC00-24]`;
  };

  const handleFeatureClick = useCallback((feature, latlng) => {
    setClickedFeaturePopup({
      position: latlng,
      properties: feature.properties,
    });
  }, []);

  const onEachFeatureWithPopup = useCallback((feature, layer) => {
    layer.on({
      click: (e) => {
        handleFeatureClick(feature, e.latlng);
      },
    });
  }, [handleFeatureClick]);

  useEffect(() => {
    const fetchGeoJSONData = async () => {
      try {
        const [response1, response2, response3] = await Promise.all([
          fetch("/DATA/OSMbased_adm1_boundary.json"),
          fetch("/DATA/OSMbased_adm2_boundary.json"),
          fetch("/DATA/OSMbased_adm3_boundary.json"),
        ]);

        const [json1, json2, json3] = await Promise.all([
          response1.json(),
          response2.json(),
          response3.json(),
        ]);

        setAdm1Data(json1);
        setAdm2Data(json2);
        setAdm3Data(json3);
        console.log("All GeoJSON boundary data loaded.");
      } catch (error) {
        console.error("Error loading GeoJSON boundary data:", error);
      }
    };
    fetchGeoJSONData();
  }, []);

  return (
    <div className="cf-dashboard-container">
      <div className="map-container-cf-dashboard">
        <MapContainer
          center={[INITIAL_VIEW_STATE.latitude, INITIAL_VIEW_STATE.longitude]}
          zoom={INITIAL_VIEW_STATE.zoom}
          style={{ width: "100%", height: "82.7vh" }}
        >
          <MapHomeControl />
          <Box
            sx={{ position: "absolute", top: 10, left: 50, zIndex: 1000 }}
          >
            <IconButton
              color="primary"
              onClick={() => setShowFilterPanel(!showFilterPanel)}
              data-filter-toggle
            >
              <Box
                sx={{
                  backgroundColor: "white",
                  borderRadius: "50%",
                  padding: "8px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: 1,
                }}
              >
                <FilterAltIcon sx={{ color: "#0d6efd", fontSize: 32 }} />
              </Box>
            </IconButton>

            <AnimatePresence>
              {showFilterPanel && (
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -20 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <div className="FilterPanel">
                    <div className="FilterPanel-container">
                      <div className="date-selector">
                        <h4 className="dropdown-heading">Date:</h4>
                        <button
                          onClick={handlePrevDate}
                          className="date-nav-button"
                          disabled={selectedDateIndex === 0}
                        >
                          <FontAwesomeIcon icon={faArrowCircleLeft} />
                        </button>
                        {/* --- MODIFIED DATE DISPLAY --- */}
                        <div className="selected-date-display">
                          {formatDateForDisplay(selectedDate, selectedDateIndex)}
                        </div>
                        <button
                          onClick={handleNextDate}
                          disabled={
                            selectedDateIndex === hardcodedDates.length - 1
                          }
                          className="date-nav-button"
                        >
                          <FontAwesomeIcon icon={faArrowCircleRight} />
                        </button>
                      </div>
                    </div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </Box>

          <LayersControl position="topright">
            <LayersControl.BaseLayer name="OpenStreetMap" checked>
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            </LayersControl.BaseLayer>

            <LayersControl.Overlay checked name={`Fire Risk Layer (${selectedDate})`}>
              <GeoTIFFBaseLayer
                tiffUrl={`/DATA/FireRisk/final_fire_risk_${selectedDate}_masked.tif`}
                layerName="Fire Risk Layer"
              />
            </LayersControl.Overlay>

            {adm1Data && (
              <LayersControl.Overlay name="Municipality">
                <GeoJSON
                  data={adm1Data}
                  style={() => ({
                      color: "#000000",
                      weight: 2,
                      opacity: 0.7,
                      fillOpacity: 0.1
                  })}
                  onEachFeature={onEachFeatureWithPopup}
                />
              </LayersControl.Overlay>
            )}
            {adm2Data && (
              <LayersControl.Overlay name="Post Admin">
                <GeoJSON
                  data={adm2Data}
                  style={() => ({
                      color: "#000000",
                      weight: 1.5,
                      opacity: 0.7,
                      fillOpacity: 0.1
                  })}
                  onEachFeature={onEachFeatureWithPopup}
                />
              </LayersControl.Overlay>
            )}
            {adm3Data && (
              <LayersControl.Overlay name="Suco" checked>
                <GeoJSON
                  data={adm3Data}
                  style={() => ({
                      color: "#000000",
                      weight: 1,
                      opacity: 0.7,
                      fillOpacity: 0.1
                  })}
                  onEachFeature={onEachFeatureWithPopup}
                />
              </LayersControl.Overlay>
            )}
          </LayersControl>

          {info && (
            <div
              ref={infoPanelRef}
              style={{
                position: "absolute",
                bottom: "70px",
                left: "12px",
                fontSize: "12px",
                zIndex: 1000,
                padding: "10px 14px",
                borderRadius: "10px",
                background: "rgba(255, 255, 255, 0.9)",
                backdropFilter: "blur(10px) brightness(1.1)",
                WebkitBackdropFilter: "blur(10px) brightness(1.1)",
                border: "1px solid rgba(0, 0, 0, 0.08)",
                boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15), inset 0 1px 2px rgba(255, 255, 255, 0.5)",
                color: "#333333",
                fontWeight: "500",
                maxWidth: "320px",
                lineHeight: "1.4",
              }}
            >
              72 hour fire risk probability information based on latest data is available from NDVI, LST.
            </div>
          )}
          <InfoButton onClick={() => setInfo(!info)} />

          {clickedFeaturePopup && clickedFeaturePopup.properties && (
            <Popup
              position={clickedFeaturePopup.position}
              onClose={() => setClickedFeaturePopup(null)}
            >
              <div style={{ paddingRight: '10px' }}>
                <h5>Suco Details:</h5>
                {clickedFeaturePopup.properties.ADM1 && (
                    <p><strong>Municipality:</strong> {clickedFeaturePopup.properties.ADM1}</p>
                )}
                {clickedFeaturePopup.properties.ADM2 && (
                    <p><strong>Post Admin:</strong> {clickedFeaturePopup.properties.ADM2}</p>
                )}
                {clickedFeaturePopup.properties.ADM3 && (
                    <p><strong>Suco:</strong> {clickedFeaturePopup.properties.ADM3}</p>
                )}

                {(clickedFeaturePopup.properties.Population ||
                  clickedFeaturePopup.properties.Male ||
                  clickedFeaturePopup.properties.Female ||
                  clickedFeaturePopup.properties.Household ||
                  clickedFeaturePopup.properties.Area_sqkm) && (
                    <hr style={{ margin: '5px 0' }} />
                )}

                {clickedFeaturePopup.properties.Population && (
                    <p><strong>Total Population:</strong> {clickedFeaturePopup.properties.Population.toLocaleString()}</p>
                )}
                {clickedFeaturePopup.properties.Male && (
                    <p><strong>Total Male:</strong> {clickedFeaturePopup.properties.Male.toLocaleString()}</p>
                )}
                {clickedFeaturePopup.properties.Female && (
                    <p><strong>Total Female:</strong> {clickedFeaturePopup.properties.Female.toLocaleString()}</p>
                )}
                {clickedFeaturePopup.properties.Household && (
                    <p><strong>Households:</strong> {clickedFeaturePopup.properties.Household.toLocaleString()}</p>
                )}
                {clickedFeaturePopup.properties.Area_sqkm && (
                    <p><strong>Area (km²):</strong> {clickedFeaturePopup.properties.Area_sqkm.toFixed(2)}</p>
                )}
              </div>
            </Popup>
          )}

          <MapLegendControl
            sections={[{
              items: [
                { label: "No-Risk", color: "rgb(148, 203, 85)" },
                { label: "Low-Risk", color: "rgb(243, 235, 18)" },
                { label: "Medium-Risk", color: "rgb(243, 155, 58)" },
                { label: "High-Risk", color: "rgb(230, 45, 58)" },
              ],
            }]}
          />
        </MapContainer>
      </div>
    </div>
  );
};

export default CFDashboard;